

/****************************************************************************

  Generated by const.tst - please don't make any changes in this file

****************************************************************************/



  export enum LogType {
      Log = 0,
      Debug = 1,
      Info = 2,
      Error = 3,
      Warning = 4,
  }

